import { render, staticRenderFns } from "./ChangeApprovalOrder.vue?vue&type=template&id=4788d8ee"
import script from "./ChangeApprovalOrder.ts?vue&type=script&lang=ts&external"
export * from "./ChangeApprovalOrder.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports